import { withStyles } from '@material-ui/core';

import CheckBoxGroup from './component';
import styles from './styles';

export default withStyles(styles)(CheckBoxGroup);
